<template>
    <div class="md-layout md-gutter mb-2.5">
        <div class="md-layout-item md-size-100">
            <md-button class="md-default md-icon-button md-raised my-0" @click="$router.back()">
                <font-awesome-icon class="md-icon" :icon="['fa', 'arrow-alt-circle-left']" />
                <span class="leading-none ml-2 font-medium">{{ text }}</span>
            </md-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ButtonGoBack",
    props: {
        text: String
    }
}
</script>

<style scoped>

</style>
